<template>
   <div class="course_head">
    <div class="container">
      <div class="wrapper">
        <div class="course_title">
          <h1>{{ title }}</h1>
          <p>{{ subtitle }}</p>
        </div>

        <ul class="info">
          <li class="cost">
            <p>{{ calculationEpisode }}</p>
            <p>{{ collectionPoint }}
              <span v-show="collectionPoint !== collectionViewPoint" class="cost_delet">
                {{ collectionViewPoint }}
              </span>
              {{singleEpisodePoint}}
              </p>
          </li>
          <li class="launchDate">{{ addedTime }}<span> 上架</span></li>
        </ul>
        <ul class="share">
          <ShareNetwork
            network="facebook"
            :url= pageUrl
            title=""
            description=""
            quote=""
            hashtags="一刻鯨選"
            tag="li"
            class="fb"
          >
            <a href="javascript:void(0)">分享</a>
          </ShareNetwork>
          <ShareNetwork
            network="line"
            :url= pageUrl
            title=""
            description=""
            quote=""
            hashtags=""
            tag="li"
            class="line"
          >
            <a href="javascript:void(0)">分享</a>
          </ShareNetwork>

          <li v-show="!isAppUserAgent" class="others">
            <a v-bind:href="qrCodeValue">在 App 開啟</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="image"><img v-bind:src="imgCover"></div>
  </div>
</template>
<script>
export default {
  name: 'CourseHead',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    calculationEpisode: {
      type: String,
      default: ''
    },
    collectionPoint: {
      type: String,
      default: ''
    },
    collectionViewPoint: {
      type: String,
      default: ''
    },
    singleEpisodePoint: {
      type: String,
      default: ''
    },
    addedTime: {
      type: String,
      default: ''
    },
    pageUrl: {
      type: String,
      default: ''
    },
    isAppUserAgent: {
      type: Boolean,
      default: false
    },
    qrCodeValue: {
      type: String,
      default: ''
    },
    imgCover: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.course_head {
  .course_title {
    margin-bottom: 11px;
    @media screen and (min-width: 768px) {
      margin-bottom: 30px;
      h1 {
        margin-bottom: 12px;
      }
    }
  }
  .cost {
    > *:not(:last-child) {
      margin-bottom: 5px;
    }
    p {
      margin-bottom: 0;
      font-size: 1.4rem;
      font-weight: 500;
    }
    .cost_delet {
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
      text-decoration:line-through;
      margin-left: 5px;
      opacity: 0.5;
    }
    @media screen and (min-width: 768px) {
      p {
        margin-bottom: 0;
        font-size: 1.8rem;
      }
    }
  }
  .info {
    align-items: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Course/components/CourseHead.vue